export default["__VITE_ASSET__B__fWlob__","__VITE_ASSET__19kFjlyp__"];